document.addEventListener('DOMContentLoaded', function() {
  let loading = false;
  const productGrid = document.querySelector('#product-grid');
  const paginationWrapper = document.querySelector('.pagination-wrapper') || document.querySelector('[class*="pagination"]')?.parentElement;
  
  if (!productGrid || !paginationWrapper) return;
  
  const nextLink = paginationWrapper.querySelector('a[aria-label*="next" i], a[aria-label*="Next" i]');
  if (!nextLink) return;
  
  // Hide pagination
  if (paginationWrapper) {
    paginationWrapper.style.display = 'none';
  }
  
  // Create loading indicator
  const loadingDiv = document.createElement('div');
  loadingDiv.className = 'infinite-scroll-loading';
  loadingDiv.style.cssText = 'text-align: center; padding: 20px; display: none;';
  loadingDiv.innerHTML = '<div class="loading-overlay gradient"></div><p>Loading more products...</p>';
  productGrid.parentElement.appendChild(loadingDiv);
  
  function loadMore() {
    if (loading) return;
    
    const next = document.querySelector('.pagination-wrapper a[aria-label*="next" i], .pagination-wrapper a[aria-label*="Next" i], [class*="pagination"] a[aria-label*="next" i]');
    if (!next) return;
    
    loading = true;
    loadingDiv.style.display = 'block';
    
    fetch(next.href)
      .then(response => response.text())
      .then(data => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');
        const newProducts = doc.querySelectorAll('#product-grid > li');
        const newPaginationWrapper = doc.querySelector('.pagination-wrapper') || doc.querySelector('[class*="pagination"]')?.parentElement;
        
        newProducts.forEach(product => {
          productGrid.appendChild(product.cloneNode(true));
        });
        
        if (newPaginationWrapper && newPaginationWrapper.querySelector('a[aria-label*="next" i]')) {
          if (paginationWrapper) {
            paginationWrapper.innerHTML = newPaginationWrapper.innerHTML;
            paginationWrapper.style.display = 'none';
          }
        } else {
          if (paginationWrapper) paginationWrapper.remove();
        }
        
        loadingDiv.style.display = 'none';
        loading = false;
      })
      .catch(error => {
        console.error('Error loading products:', error);
        loadingDiv.style.display = 'none';
        loading = false;
      });
  }
  
  window.addEventListener('scroll', function() {
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 800) {
      loadMore();
    }
  });
});
